<script setup lang="ts">
defineProps<{
  icon: string[],
}>();
</script>

<template>
  <div class="relative rounded-full border w-9 h-9 flex items-center justify-center">
    <slot name="addonBefore" />
    <ClientOnly>
      <!-- https://github.com/FortAwesome/vue-fontawesome/issues/394 -->
      <UiFaIcon :icon="icon" />
    </ClientOnly>
    <slot name="addonAfter" />
  </div>
</template>
